import { useState, useCallback } from 'react';

export const useContextStack = (onPush) => {
  const [contextStack, setContextStack] = useState([]);

  const pushContext = useCallback((id, width, height, instanceId = null) => {
    setContextStack(prev => {
      // Prevent pushing if ID is already in the stack (avoid loops/duplicates)
      if (prev.some(ctx => ctx.id === id)) {
        return prev;
      }
      return [...prev, { id, width, height, instanceId }];
    });

    // Call onPush callback if provided
    if (onPush) {
      onPush();
    }
  }, [onPush]);

  const popContext = useCallback(() => {
    setContextStack(prev => prev.slice(0, -1));
  }, []);

  const setContextAtIndex = useCallback((index, onExit) => {
    const prev = contextStack;
    const popped = prev.slice(index + 1);
    setContextStack(prev.slice(0, index + 1));

    // Call onExit callback if provided with the popped contexts
    if (onExit && popped.length > 0) {
      onExit(popped);
    }
  }, [contextStack]);

  const clearContext = useCallback(() => {
    setContextStack([]);
  }, []);

  const getCurrentContext = useCallback(() => {
    return contextStack.length > 0 ? contextStack[contextStack.length - 1] : null;
  }, [contextStack]);

  return {
    contextStack,
    setContextStack,
    pushContext,
    popContext,
    setContextAtIndex,
    clearContext,
    getCurrentContext
  };
};
